<div class="notification-settings-container">
  @if (isLoading) {
    <div class="notification-settings-skeleton">
      <!-- In-App Notifications Section -->
      <div class="skeleton-section border-bottom">
        <div class="skeleton-header">
          <div class="skeleton-icon"></div>
          <div class="skeleton-title" style="width: 150px"></div>
        </div>

        @if (hasLeadsPermission) {
          <div class="skeleton-item" style="margin-top: 15px">
            <div class="skeleton-checkbox"></div>
            <div class="skeleton-text" style="width: 280px"></div>
          </div>
        }

        <div class="skeleton-item">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 260px"></div>
        </div>

        @if (hasDeeprootsPermission) {
          <div class="skeleton-item deeproots-section">
            <div
              class="skeleton-dropdown-label"
              style="width: 160px; height: 16px; margin-bottom: 6px"
            ></div>
            <div
              class="skeleton-dropdown-subtext"
              style="width: 320px; height: 12px; margin-bottom: 8px"
            ></div>
            <div class="skeleton-select"></div>
          </div>
        }
      </div>

      <!-- Email Notifications Section -->
      <div class="skeleton-section">
        <div class="skeleton-header-row">
          <div class="skeleton-header">
            <div class="skeleton-icon"></div>
            <div class="skeleton-title" style="width: 130px"></div>
          </div>
          <div class="skeleton-badge"></div>
        </div>

        <div class="skeleton-item">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 270px"></div>
        </div>

        <div class="skeleton-item">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 250px"></div>
        </div>

        @if (hasDeeprootsPermission) {
          <div class="skeleton-item">
            <div class="skeleton-checkbox"></div>
            <div class="skeleton-text" style="width: 290px"></div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="settings-content-fade">
      <!-- In-App Notifications Section -->
      <div class="settings-section" id="tour-app-notifications">
        <h3 class="section-title in-app-section-title">
          <svg
            class="section-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          In-App Notifications
        </h3>

        @if (hasLeadsPermission) {
          <div class="setting-item" style="margin-top: 15px">
            <label class="checkbox-container">
              <input type="checkbox" [(ngModel)]="localSettings.shared_notes" />
              <span class="checkmark"></span>
              <span class="label-text"
                >Get notified when someone shares a lead note with you</span
              >
            </label>
          </div>
        }

        <div class="setting-item">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="localSettings.record_visibility"
            />
            <span class="checkmark"></span>
            <span class="label-text"
              >Get notified when business record access changes</span
            >
          </label>
        </div>

        @if (hasDeeprootsPermission) {
          <div class="setting-item deeproots-section">
            <label class="dropdown-container">
              <span class="label-text">DeepRoots Submissions:</span>
              <span class="sub-text"
                >Choose how you want to be notified about DeepRoots form
                submissions</span
              >
              <select [(ngModel)]="localSettings.deeproots">
                @for (option of deepRootsOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>
          </div>
        }
      </div>

      <!-- Email Notifications Section -->
      <div class="settings-section" id="tour-email-notifications">
        <div class="section-header-row">
          <h3 class="section-title">
            <svg
              class="section-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
              ></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            Email Notifications
          </h3>

          @if (!isEmailInDnd) {
            <div class="status-badge success">
              <span class="badge-icon">✔</span>
              Subscribed
            </div>
          }
        </div>

        @if (isEmailInDnd) {
          <div class="dnd-alert-banner">
            <div class="dnd-alert-content">
              <div class="dnd-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M12 8V12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <circle cx="12" cy="16" r="1" fill="currentColor" />
                </svg>
              </div>
              <div class="dnd-text">
                <span class="dnd-title">Email notifications are disabled</span>
                <span class="dnd-description">
                  You are currently unsubscribed from emails. Update your
                  preferences to receive notifications.
                </span>
              </div>
            </div>
            <button
              type="button"
              class="dnd-action-btn"
              (click)="onResumeEmails()"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 11L12 14L22 4"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 12V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H16"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Resume Emails
            </button>
          </div>
        }

        <div class="setting-item">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="localSettings.daily_unread_notifications_email"
            />
            <span class="checkmark"></span>
            <span class="label-text"
              >Receive a daily summary of unread notifications</span
            >
          </label>
        </div>

        <div class="setting-item">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="localSettings.share_record_email"
            />
            <span class="checkmark"></span>
            <span class="label-text"
              >Email me when a record is shared with me</span
            >
          </label>
        </div>

        @if (hasDeeprootsPermission) {
          <div class="setting-item">
            <label class="checkbox-container">
              <input
                type="checkbox"
                [(ngModel)]="localSettings.deeproots_matched_email"
              />
              <span class="checkmark"></span>
              <span class="label-text"
                >Email me when a matching DeepRoots submission comes</span
              >
            </label>
          </div>
        }
      </div>
    </div>
  }
</div>
